<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right" ref="search">
      <el-form-item label="归集仓名称" prop="warehouseName">
        <el-input
          v-model="search.warehouseName"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item label="归集仓编号" prop="warehouseNo">
        <el-input
          v-model="search.warehouseNo"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item label="是否WMS仓库" prop="wmsWarehouse">
        <el-select
          v-model="search.wmsWarehouse"
          placeholder="请选择"
          clearable
          style="width: 100%"
        >
          <el-option
            :label="item.name"
            :key="item.key"
            :value="item.value"
            style="width: 100%"
            v-for="item in wmsWarehouseOption"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="归集仓状态" prop="status">
        <el-select
          v-model="search.status"
          placeholder="请选择"
          clearable
          style="width: 100%"
        >
          <el-option
            :label="item.name"
            :key="item.value"
            :value="item.value"
            style="width: 100%"
            v-for="item in warehouseStatus"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="row-bg">
      <el-button type="primary" size="medium" @click="goAdd('add')"
        >添加归集仓</el-button
      >
      <el-button type="primary" size="medium" @click="batchAddFun"
        >批量添加归集仓</el-button
      >
      <el-button type="primary" size="medium" @click="exportExcel()"
        >导出</el-button
      >
      <el-button type="primary" size="medium" @click="handleSearch()"
        >查询</el-button
      >
      <el-button size="medium" @click="resetForm">重置</el-button>
    </div>
    <el-table
      ref="checktableData"
      :data="list"
      v-loading="listLoading"
      :reserve-selection="true"
      center
      height="60vh"
    >
      <el-table-column
        label="归集仓编码编号"
        prop="warehouseNo"
        width="180"
      ></el-table-column>
      <el-table-column
        label="归集仓名称"
        prop="warehouseName"
        width="180"
      ></el-table-column>
      <el-table-column label="归集仓状态" width="120">
        <template slot-scope="scope">{{
          warehouseStatusObj[scope.row.status]
        }}</template>
      </el-table-column>
      <el-table-column label="是否WMS仓库" prop="wmsWarehouse" width="120">
        <template slot-scope="scope">{{
          scope.row.wmsWarehouse === 0
            ? "是"
            : scope.row.wmsWarehouse === 1
            ? "否"
            : ""
        }}</template>
      </el-table-column>
      <el-table-column
        label="WMS账仓编码"
        prop="financeWarehouseNo"
        width="120"
      ></el-table-column>
      <el-table-column
        label="仓库地址"
        prop="address"
        width="120"
      ></el-table-column>
      <el-table-column label="仓库联系人" prop="contact" width="120">
      </el-table-column>
      <el-table-column label="联系电话" prop="tel" width="120">
      </el-table-column>
      <el-table-column
        label="操作人"
        prop="createdName"
        width="120"
      ></el-table-column>
      <el-table-column label="创建时间" prop="createdDate" width="140">
        <template slot-scope="scope">{{
          scope.row.createdDate | formatDateTimeDefault
        }}</template>
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="toggle(scope.row)">{{
            scope.row.status === 1 ? "启用" : "停用"
          }}</el-button>
          <el-button type="text" @click="goAdd('edit', scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.currPage"
        :page-size="search.pageSize"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>

    <commonBath
      ref="batchCommonRef"
      @opera-success="getList"
      :errUrl="'/autoapp-default-server-recovery/api/warehouse/downLoadFailInfo'"
      :downloadTemplateUrl="'/autoapp-default-server-recovery/api/warehouse/downloadTemplate'"
      :importUrl="'/autoapp-default-server-recovery/api/warehouse/importWarehouse'"
      :title="'批量添加归集仓'"
      :uploadTitle="'导入归集仓'"
    ></commonBath>
    <addWarehouseDialog
      ref="AddDialogRef"
      @opera-success="getList"
    ></addWarehouseDialog>
  </div>
</template>
<script>
import commonBath from "./components/commonBath.vue";
import addWarehouseDialog from "./components/addWarehouseDialog";
import {
  findWarehouseByDto,
  updateWarehouseStatus,
  findWarehouseStatusOption,
  findWmsWarehouseOption,
} from "@/api/wareHouse";

export default {
  name: "warehouse",
  components: {
    addWarehouseDialog,
    commonBath,
  },
  filters: {},

  data() {
    return {
      list: [],
      total: 0, //列表总条数
      listLoading: false,
      warehouseStatus: [],
      warehouseStatusObj: {},
      wmsWarehouseOption: [],
      wmsWarehouseOptionObj: {},
      search: {
        warehouseName: null,
        warehouseNo: null,
        wmsWarehouse: null,
        status:null,  //归集仓状态
        currPage: 1, //当前页
        pageSize: 10,
      },
    };
  },
  async created() {
    this.getWmsWarehouseOption();
    this.getWarehouseStatusOption();
  },
  mounted() {
    this.getList();
  },
  methods: {
    //获取是否 wms 仓库
    async getWmsWarehouseOption() {
      let { data, statusCode } = await findWmsWarehouseOption();
      if (statusCode == 200) {
        this.wmsWarehouseOption = data;
        this.wmsWarehouseOptionObj = this.wmsWarehouseOption.reduce(
          (obj, item) => {
            obj[item.value] = item.name;
            return obj;
          },
          {}
        );
      }
    },
    //获取归集仓状态
    async getWarehouseStatusOption() {
      let { data, statusCode } = await findWarehouseStatusOption();
      if (statusCode == 200) {
        this.warehouseStatus = data;
        this.warehouseStatusObj = this.warehouseStatus.reduce((obj, item) => {
          obj[item.value] = item.name;
          return obj;
        }, {});
      }
    },
    handleSearch() {
      this.search.currPage = 1;
      this.getList();
    },
    async getList() {
      let { data, statusCode, total } = await findWarehouseByDto(this.search);

      if (statusCode == 200) {
        this.list = data;
        this.total = total;
      }
    },
    resetForm() {
      this.search = this.$options.data().search;
    },

    handleSizeChange(val) {
      this.search.currPage = 1;
      this.search.pageSize = val;
      this.getList();
    },
    handleCurrentChange() {
      this.getList();
    },

    async goAdd(type, rowData) {
      this.$refs.AddDialogRef.openDialog(
        type,
        rowData,
        this.wmsWarehouseOption
      );
    },
    //批量添加承运商
    batchAddFun() {
      this.$refs.batchCommonRef.openDialog();
    },
    //启用/停用
    toggle(row) {
      this.$dialog({
        title: row.status === 0 ? "停用确认" : "启用确认",
        content:
          row.status === 0
            ? "确认停用归集仓，后续订单将不再分流给该归集仓，不影响正在进行的单"
            : "请确认是否启用",
        cancel_buttton: "取消",
        ok_buttton: "确认",
        width: "400px",
        footBtn: "card",
        dialogType: "sighicon",
        onOk: () => {
          this.confirmToggle(row);
        },
        onCancel: () => {
          console.log("cancel");
        },
      });
    },
    //确认启停
    async confirmToggle(row) {
      if(!row.warehouseNo){
        this.$message.warning('数据异常，无法操作')
        return
      }
      let { statusCode } = await updateWarehouseStatus(
        row.warehouseNo,
        row.status === 0 ? 1 : 0
      );
      if (statusCode == 200) {
        this.$message.success(row.status === 0 ? "停用成功" : "启用成功");
        this.getList();
      }
    },
    //导出
    exportExcel() {
      let url = `/autoapp-default-server-recovery/api/warehouse/export`;
      this.HttpService.post(url, {}).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.goodsStyle {
  display: flex;
  align-items: center;
}
.flex {
  display: flex;
  align-items: center;
  // margin: 0 20px;
  padding: 0 20px;
  span {
    min-width: 100px;
  }
}
.row-bg {
  margin-bottom: 15px;
}
.btnBox {
  margin-bottom: 20px;
}
.data-view-wrap {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  .item-wrap {
    margin-right: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #00b882;
    padding: 10px;
    height: auto;
    color: #fff;

    .unit {
      margin-left: 20px;
      max-width: 300px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      > span {
        font-size: 20px;
        padding-right: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/warehouse.vue